export default __webpack_public_path__ + "static/media/tj.5cc0d458.jpg";